import { Box, CircularProgress } from '@material-ui/core';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ShoppingAPI from '../../../store/shopping/shopping.api';

export const StripeOauth = () => {
    const location = useLocation();

    useEffect(() => {
        if (location && location.search) {
            const queryParams = new URLSearchParams(location.search);
            localStorage.setItem("x-stripe-code", queryParams.get("code"));
            ShoppingAPI.GetAccessToken(queryParams.get("code")).then((x) => {
                localStorage.setItem("x-stripe-account", x.data.stripe_user_id);
                localStorage.setItem("x-stripe-accessToken", x.data.access_token);
                localStorage.setItem("x-stripe-publishable-key", x.data.stripe_publishable_key);
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                setTimeout(() => {
                    window.close();
                }, 3000)
            })
        }
    }, [location]);

    return (
        <Box width="100vw" height="100vh" display={"flex"} justifyContent="center" alignItems={"center"}>
            <CircularProgress color="secondary" size={100} />
        </Box>
    )
}
